export const NEW_GENERIC_ORDER_SUCCESS = 'NEW_GENERIC_ORDER_SUCCESS';
